import { render, staticRenderFns } from "./conform.vue?vue&type=template&id=a4fc10cc&scoped=true&"
import script from "./conform.vue?vue&type=script&lang=js&"
export * from "./conform.vue?vue&type=script&lang=js&"
import style0 from "./conform.vue?vue&type=style&index=0&id=a4fc10cc&lang=scss&scoped=true&"
import style1 from "./conform.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fc10cc",
  null
  
)

export default component.exports